import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-manage-imaging-center",
  templateUrl: "./manage-imaging-center.component.html",
  styleUrls: ["./manage-imaging-center.component.scss"],
})
export class ManageImagingCenterComponent implements OnInit {
  rowsData = [
    { title: "Name", sorting: true, name: "tcName", underline: true },
    { title: "Address", tooltip: true },
    { title: "Member Since", dateFitler: true },
    { title: "Country" },
    { title: "Hold or Unhold" },
  ];

  columnsData = [];

  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "createdOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  addressdata: any = "";
  testcenter = [];
  dailypageno = 1;
  countryData = [];
  stateData = [];
  selectedCountry: any = "";
  selectedState: any = "";
  country: ["default"];
  state: ["default"];
  countryidadmin: any = "";
  stateidadmin: any = "";

  reverse = true;
  tcCode = "";
  key = "name";
  key1 = "name";
  key2 = "createdOn";

  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllManageTCListAdmin("");
    sessionStorage.setItem("page", "manageic");
    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getAllManageTCListAdmin(event);
      }
    });
    this.checkUrl();
    this.getAllCountry();
  }

  goToIc(tcId) {
    this.tcCode = localStorage.getItem("testCode");
    sessionStorage.setItem("testId", tcId);
    this.router.navigate([this.tcCode + "/basicinfo"]);
  }
  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getAllManageTCListAdmin("");
  }

  refreshPatient() {
    this.selectedCountry = "";
    this.countryidadmin = "";
    this.stateidadmin = "";
    this.selectedState = "";
    this.searchText = "";
    this.searchPatient = "";
    this.getAllManageTCListAdmin("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getAllManageTCListAdmin("");
  }

  getAllManageTCListAdmin(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
      };
    }
    this.appService.getAllManageTCListAdminwithFilter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.testcenter = res["entity"];
            for (let index = 0; index < this.testcenter.length; index++) {
              this.testcenter[index].addressdata = "";
              if (
                this.testcenter[index].address &&
                this.testcenter[index].address.addressLine1
              ) {
                this.testcenter[index].addressdata +=
                  this.testcenter[index].address.addressLine1 + ",";
              }
              if (
                this.testcenter[index].address &&
                this.testcenter[index].address.addressLine2
              ) {
                this.testcenter[index].addressdata +=
                  this.testcenter[index].address.addressLine2 + ",";
              }
              if (
                this.testcenter[index].address &&
                this.testcenter[index].address.cityName
              ) {
                this.testcenter[index].addressdata +=
                  this.testcenter[index].address.cityName + ",";
              }
              if (
                this.testcenter[index].address &&
                this.testcenter[index].address.state &&
                this.testcenter[index].address.state.state
              ) {
                this.testcenter[index].addressdata +=
                  this.testcenter[index].address.state.state + ",";
              }
              if (
                this.testcenter[index].address &&
                this.testcenter[index].address.country &&
                this.testcenter[index].address.country.country
              ) {
                this.testcenter[index].addressdata +=
                  this.testcenter[index].address.country.country + ".";
              }
            }
            this.totalItems = res["count"];
          }
        } else {
          this.testcenter = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getAllManageTCListAdmin(event);
  }

  changeHoldStatus(tcid: any, status: any) {
    const data = {
      tcId: tcid,
      active: status,
    };
    this.appService.changeHoldStatusAdmin(data).subscribe((res) => ({}));
  }

  getAllCountry() {
    this.appService.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  onChange(event) {
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.stateidadmin = "";
    this.getAllStateByCountry(event.id);
    this.getAllManageTCListAdmin("");
  }

  getAllStateByCountry(countryid) {
    this.appService.getState(countryid).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.stateData = res["entity"];
      } else {
        this.stateData = [];
      }
    });
  }

  onChangeState(event) {
    sessionStorage.setItem("stateidadmin", this.selectedState.id);
    this.stateidadmin = sessionStorage.getItem("stateidadmin");
    this.getAllManageTCListAdmin("");
  }
}
